
import {Component, Vue} from 'vue-property-decorator';
import {currentUserModule, exportsModule, studyInstitutesModule, studyModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import DataExchangeTable from "@/components/exports/DataExchangeTable.vue";
import Rights = MdbsCore.Rights;
import {startDownload} from "@/auxillary/export.helper";
import StudyInstituteShortDto = MdbsCore.StudyInstituteShortDto;

@Component({
  components: {DataExchangeTable}
})
export default class FinalExport extends Vue {

  instituteId: string = "";
  allSelected: boolean = false;

  get studyId() {
    return studyModule.study.id;
  }

  get institutes() {
    return studyInstitutesModule.studyInstitutes
        .filter(i => i.studyId == this.studyId)
        .sort((a, b) => (a.identifier ?? "") > (b.identifier ?? "") ? 1 : -1);
  }

  async mounted() {
    await studyInstitutesModule.loadAll();
  }

  getStudyInstituteName(studyInstitute: StudyInstituteShortDto) {
    return studyInstitute.identifier + " - " + studyInstitute.displayName
  }

  resetInstitutes() {
    this.instituteId = "";
  }

  get loading() {
    return studyInstitutesModule.isLoading || exportsModule.isLoading;
  }

  async generateFinalExport() {
    this.$emit('generate');
    const institutes = this.allSelected ? this.institutes.map(i => i.id) : [this.instituteId];
    await exportsModule.generateFinalExport({studyId: studyModule.study.id, studyInstitutes: institutes})
        .then(response => {
          if (response) {
            startDownload(response.data, response.fileName ?? "");
          }
        }).catch(console.error)
  }

  get canGenerateFinalExport() {
    return currentUserModule.hasRight(Rights.FinalExportGetCmd);
  }
}
